import React, { useEffect, useState } from "react";
import { RoutesLink } from "../../../ApiHelper/RoutesLink";
import ViewIcon from "../../../components/Icons/ViewIcon";
import CommonTable from "../../../components/comman/CommonTable";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { apiUrl } from "../../../ApiHelper/ApiUrl";

const PendingPurchaseRequests = ({ siteId }) => {
  const navigate = useNavigate();
  const [pageStates, setPageStates] = useState({
    tableLoader: false,
    purchaseRequestList: [],
  });

  useEffect(() => {
    GetPurchaseRequest();
  }, [siteId]);

  const GetPurchaseRequest = () => {
    let options = {
      method: "GET",
    };
    const Url =
      apiUrl.get_purchase_request +
      "?" +
      `pageNumber=1&pageSize=5&status=pending${siteId ? `&siteId=${siteId}` : ""}`;
    setPageStates((pre) => ({
      ...pre,
      tableLoader: !pre.tableLoader,
    }));
    callApi(Url, options).then((res) => {
      setPageStates((pre) => ({
        ...pre,
        tableLoader: !pre.tableLoader,
      }));
      if (res?.status === true) {
        const newData = res?.data?.purchaseRequest?.map((item) => ({
          ...item,
          createdOn: moment(item?.date).format("DD-MM-YYYY") || "--",
          expDate: moment(item?.expectedDate).format("DD-MM-YYYY") || "--",
          siteName: item?.site?.name,
          person: item?.user?.name,
          purchaseRequestStatus: item?.status,
          reqType:
            item?.type === "supplyRequest"
              ? "Supply Request"
              : "Service Request",
        }));
        setPageStates((pre) => ({
          ...pre,
          purchaseRequestList: newData,
        }));
      }
    });
  };

  const TableHeading = [
    { value: "requestNumber", label: "Request No." },
    { value: "createdOn", label: "Created At" },
    { value: "expDate", label: "Expected At" },
    { value: "siteName", label: "Site Name" },
    { value: "person", label: "Created By" },
    { value: "reqType", label: "Type" },
    { value: "purchaseRequestStatus", label: "Status" },
  ];

  const HandleView = (data) => {
    navigate(RoutesLink.purchase_request_detail + `/${data?.id}`);
  };

  const ActionDataForPending = [
    {
      label: "view",
      className: "btn btn-link",
      icon: <ViewIcon />,
      title: "view",
      clickHandler: HandleView,
    },
  ];

  return (
    <div className="col-12 col-lg-6">
      <div className="card height-full">
        <div className="card-body">
          <div className="card-head">
            <h3 className="card-title">Pending Purchase Requests</h3>

            <button
              type="button"
              className="btn btn-outline-primary py-1"
              onClick={() => navigate(RoutesLink?.purchase_request)}
            >
              View All
            </button>
          </div>
          <CommonTable
            TableHeading={TableHeading}
            TableData={pageStates?.purchaseRequestList}
            ActionData={ActionDataForPending}
            isLoading={pageStates?.tableLoader}
          />
        </div>
      </div>
    </div>
  );
};

export default PendingPurchaseRequests;
